module.exports = __webpack_public_path__ + "static/media/2.48f2055a.jpg";